import React from 'react';
import { Meta } from 'types/common';
import { getBrowserTimezone, getBrowserTimezoneOffset } from 'utils/common';
import { providerAvailabilityList } from 'api/appointmentSetting';
import { getUserId } from 'utils/localstore';
import { SUPPORT_TIME_ZONE } from 'constants/common';

let globalMySettingTimezone: string = '';

const useTimezone = (forceLoad?: boolean): [Meta[], Meta, boolean, boolean, () => void] => {
    const [loadingMySettingTimezone, setLoadingMySettingTimezone] = React.useState(false);
    const [mySettingTimezone, setMySettingTimezone] = React.useState(globalMySettingTimezone);
    const timezoneOffset = getBrowserTimezoneOffset();

    // 从前端读取配置，兼容冬/夏令时
    const data = SUPPORT_TIME_ZONE.map((item) => {
        return {
            label: item.label,
            value: item.dictKey,
        };
    });

    const fetchData = async () => {
        try {
            setLoadingMySettingTimezone(true);
            const uid = getUserId();
            const result = await providerAvailabilityList(uid!);
            if (!result.error) {
                const timezone: string = result?.data?.data?.timezone;
                globalMySettingTimezone = timezone;
                setMySettingTimezone(globalMySettingTimezone);
            }
            setLoadingMySettingTimezone(false);
        } catch (e) {
            console.error(e);
            setLoadingMySettingTimezone(false);
        }
    };
    React.useEffect(() => {
        if (!globalMySettingTimezone || forceLoad) {
            fetchData();
        }
    }, []);
    let myTimezone: Meta | undefined;
    if (mySettingTimezone) {
        myTimezone = data.find((item: Meta) => {
            return (item.value as string).toLowerCase() === mySettingTimezone.toLowerCase();
        });

        if (!myTimezone) {
            myTimezone = data.find((item: Meta) => {
                return item.label.includes(timezoneOffset);
            });
        }
    }

    if (!myTimezone) {
        const offset = getBrowserTimezoneOffset();
        const frontTimezone = SUPPORT_TIME_ZONE.find((item) => {
            return item.offset === offset;
        });
        if (frontTimezone) {
            myTimezone = data.find((item: Meta) => {
                return (`${item.value}`).toLowerCase() === frontTimezone.dictKey?.toLowerCase();
            });
        }
    }

    if (!myTimezone) {
        myTimezone = {
            label: getBrowserTimezone(),
            value: getBrowserTimezone(),
        };
    }

    let isDifferentTimezoneWithBrowser = false;
    if (myTimezone) {
        const targetTimezone = SUPPORT_TIME_ZONE.find((item) => item.dictKey.toLowerCase() === (myTimezone?.value as string).toLowerCase());
        if (targetTimezone && targetTimezone.offset !== getBrowserTimezoneOffset()) {
            isDifferentTimezoneWithBrowser = true;
        }
    }

    return [data, myTimezone, isDifferentTimezoneWithBrowser, loadingMySettingTimezone, fetchData];
};

export default useTimezone;
